export default __webpack_public_path__ + "static/12-a27fcb0b1d100b00eb458ed179e15fa3.webp";